import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import Icon from '@component/icon';

import { WHITE } from '@constant/colors';

class NoticeBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hidden: false,
    };

    this.hide = this.hide.bind(this);
    this.handleTransferWindowClick = this.handleTransferWindowClick.bind(this);
  }

  componentDidMount() {
    const { autoHideTimeout, onTransferClick } = this.props.hideOptions;
    if (autoHideTimeout) {
      this.hideTimeout = setTimeout(this.hide, autoHideTimeout);
    }

    if (onTransferClick) {
      document.addEventListener('click', this.handleTransferWindowClick);
    }
  }

  componentWillUnmount() {
    if (this.props.hideOptions.onTransferClick) {
      document.removeEventListener('click', this.handleTransferWindowClick);
    }
    clearTimeout(this.hideTimeout);
    clearTimeout(this.onTransferClickTimeout);
  }

  componentDidUpdate() {
    if (this.state.hidden && this.props.onClose) {
      this.props.onClose();
    }
  }

  handleTransferWindowClick(e) {
    if (
      this.props.transferNode.node &&
      this.props.transferNode.node.contains(e.target)
    ) {
      this.onTransferClickTimeout = setTimeout(
        this.hide,
        this.props.hideOptions.onTransferClickTimeout
      );
    }
  }

  hide() {
    this.setState({ hidden: true });
  }

  render() {
    const { text, color } = this.props;

    const classnames = ['notice'];
    if (color === 'dark') {
      classnames.push(`notice--dark`);
    }

    return (
      <CSSTransition
        classNames="notice--fade"
        in={!this.state.hidden}
        timeout={500}
        unmountOnExit
      >
        <div className={classnames.join(' ')}>
          <span dangerouslySetInnerHTML={{ __html: text }} />
          <Icon type="Close" onClick={this.hide} color={WHITE} />
        </div>
      </CSSTransition>
    );
  }
}

NoticeBar.propTypes = {
  hideOptions: PropTypes.object,
  route: PropTypes.object,
  transferNode: PropTypes.object,
  onClose: PropTypes.func,
  transferState: PropTypes.string,
  text: PropTypes.string,
  color: PropTypes.oneOf(['dark']),
};

NoticeBar.defaultProps = {
  hideOptions: {
    autoHideTimeout: null,
    onTransferClick: false,
    onTransferClickTimeout: 3000,
  },
  route: {
    type: 'transfer',
  },
  transferNode: {},
  onClose: null,
};

export default NoticeBar;
